var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconbubble(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "42px",
    height: "42px",
    viewBox: "0 0 42 42",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon bubble") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Journey-13--Actions",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "5.10--LegalSite-customization",
    transform: "translate(-1216.000000, -652.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(149.000000, 146.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon-bubble",
    transform: "translate(1067.000000, 506.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "circle"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FFFFFF",
    cx: 21,
    cy: 21,
    r: 21
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fillOpacity: 0.3,
    fill: "#1DDCC0",
    cx: 21,
    cy: 21,
    r: 21
  })), /*#__PURE__*/React.createElement("g", {
    id: "check-circle",
    transform: "translate(9.000000, 9.000000)",
    fill: "#1DDCC0",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.264,8.148 L10.116,13.308 L8.136,11.328 C7.84273214,10.9855486 7.38225793,10.8363817 6.94389723,10.9418278 C6.50553654,11.047274 6.16327401,11.3895365 6.05782784,11.8278972 C5.95238167,12.2662579 6.10154861,12.7267321 6.444,13.02 L9.264,15.852 C9.4904626,16.0766238 9.79703642,16.2018441 10.116,16.2 C10.4308079,16.1986745 10.7324872,16.073693 10.956,15.852 L16.956,9.852 C17.1831752,9.62668008 17.310958,9.31996504 17.310958,9 C17.310958,8.68003496 17.1831752,8.37331992 16.956,8.148 C16.4879551,7.68273169 15.7320449,7.68273169 15.264,8.148 Z M12,5.32907052e-16 C5.372583,-2.66453526e-16 5.32907052e-16,5.372583 0,12 C-5.32907052e-16,18.627417 5.372583,24 12,24 C18.627417,24 24,18.627417 24,12 C24,8.81740212 22.7357179,5.76515517 20.4852814,3.51471863 C18.2348448,1.26428208 15.1825979,2.66453526e-16 12,5.32907052e-16 Z M12,21.6 C6.6980664,21.6 2.4,17.3019336 2.4,12 C2.4,6.6980664 6.6980664,2.4 12,2.4 C17.3019336,2.4 21.6,6.6980664 21.6,12 C21.6,14.5460783 20.5885743,16.9878759 18.7882251,18.7882251 C16.9878759,20.5885743 14.5460783,21.6 12,21.6 Z",
    id: "Shape"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconbubble);
export default __webpack_public_path__ + "static/media/Icon bubble.f1e0fca6c6be38b7b1e9dd1d654947eb.svg";
export { ForwardRef as ReactComponent };